<template>
    <v-row>
        <v-col>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="text"></v-skeleton-loader>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="text"></v-skeleton-loader>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="text@10"></v-skeleton-loader>
                </v-col>
            </v-row>
             <v-row>
                <v-col>
                    <v-skeleton-loader type="text"></v-skeleton-loader>
                </v-col>
            </v-row>
             <v-row>
                <v-col>
                    <v-skeleton-loader type="text"></v-skeleton-loader>
                </v-col>
            </v-row>
             <v-row>
                <v-col>
                    <v-skeleton-loader type="text"></v-skeleton-loader>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: "ItemFormLoader"
}
</script>

<style>

</style>